/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_EmptyInputs */

const en_admin_ai_chat_empty = /** @type {(inputs: Admin_Ai_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about members, bookings, invoices and revenue`)
};

const de_admin_ai_chat_empty = /** @type {(inputs: Admin_Ai_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fragen zu Mitgliedern, Buchungen, Rechnungen und Umsatz`)
};

const es_admin_ai_chat_empty = /** @type {(inputs: Admin_Ai_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas sobre miembros, reservas, facturas e ingresos`)
};

const fr_admin_ai_chat_empty = /** @type {(inputs: Admin_Ai_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions sur vos membres, réservations, factures et chiffre d'affaires`)
};

const nl_admin_ai_chat_empty = /** @type {(inputs: Admin_Ai_Chat_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vragen over leden, reserveringen, facturen en omzet`)
};

/** @type {(inputs: Admin_Ai_Chat_EmptyInputs) => LocalizedString} */
const it_admin_ai_chat_empty = en_admin_ai_chat_empty;

/** @type {(inputs: Admin_Ai_Chat_EmptyInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_empty = en_admin_ai_chat_empty;

/** @type {(inputs: Admin_Ai_Chat_EmptyInputs) => LocalizedString} */
const pl_admin_ai_chat_empty = en_admin_ai_chat_empty;

/** @type {(inputs: Admin_Ai_Chat_EmptyInputs) => LocalizedString} */
const hu_admin_ai_chat_empty = en_admin_ai_chat_empty;

/** @type {(inputs: Admin_Ai_Chat_EmptyInputs) => LocalizedString} */
const ro_admin_ai_chat_empty = en_admin_ai_chat_empty;

/**
* | output |
* | --- |
* | "Ask about members, bookings, invoices and revenue" |
*
* @param {Admin_Ai_Chat_EmptyInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_empty = /** @type {((inputs?: Admin_Ai_Chat_EmptyInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_EmptyInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_empty(inputs)
	if (locale === "de") return de_admin_ai_chat_empty(inputs)
	if (locale === "es") return es_admin_ai_chat_empty(inputs)
	if (locale === "fr") return fr_admin_ai_chat_empty(inputs)
	if (locale === "nl") return nl_admin_ai_chat_empty(inputs)
	if (locale === "it") return it_admin_ai_chat_empty(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_empty(inputs)
	if (locale === "pl") return pl_admin_ai_chat_empty(inputs)
	if (locale === "hu") return hu_admin_ai_chat_empty(inputs)
	return ro_admin_ai_chat_empty(inputs)
});
export { admin_ai_chat_empty as "admin.ai_chat.empty" }